module.exports = __webpack_public_path__ + "media/images/logout-5863251800d5dd91850541f0c6635fe3.png";